<script setup>
import { computed } from 'vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const tooltipText = computed(() => {
  return props.isOpen ? 'Fechar detalhes' : 'Abrir detalhes';
});

const handleClick = () => {
  emit('toggle');
};
</script>

<template>
  <button
    v-tooltip.left="tooltipText"
    class="contact-panel-toggle-button"
    :class="{ 'panel-closed': !isOpen }"
    @click.stop="handleClick"
  >
    <div class="toggle-bar">
      <!-- Seta para direita quando aberto (fechar) -->
      <svg
        v-if="isOpen"
        class="toggle-icon"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M9 5l7 7-7 7"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- Seta para esquerda quando fechado (abrir) -->
      <svg
        v-else
        class="toggle-icon"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M15 19l-7-7 7-7"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </button>
</template>

<style lang="scss" scoped>
.contact-panel-toggle-button {
  position: absolute;
  // Totalmente à esquerda da borda - como aba de fichário
  left: -20px;
  top: 120px;
  width: 20px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;

  .toggle-bar {
    width: 20px;
    height: 44px;
    background: linear-gradient(
      270deg,
      transparent 0%,
      var(--white) 40%,
      var(--white) 100%
    );
    border: 1px solid var(--s-200);
    // Arredondado só no lado esquerdo (aba de fichário)
    border-radius: 8px 0 0 8px;
    border-right: none;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: -2px 1px 4px rgba(0, 0, 0, 0.06);
    transition: all 0.2s ease;

    &:hover {
      width: 24px;
      background: var(--white);
      box-shadow: -2px 2px 6px rgba(0, 0, 0, 0.1);

      .toggle-icon {
        opacity: 0.8;
      }
    }

    &:active {
      background: var(--s-50);
    }
  }

  .toggle-icon {
    color: var(--s-500);
    opacity: 0.5;
    transition: opacity 0.2s ease;
  }

  &:focus-visible {
    .toggle-bar {
      outline: 2px solid var(--w-500);
      outline-offset: 1px;
    }
  }
}

// Dark mode
.dark {
  .contact-panel-toggle-button {
    .toggle-bar {
      background: linear-gradient(
        90deg,
        transparent 0%,
        var(--s-800) 40%,
        var(--s-800) 100%
      );
      border-color: var(--s-700);

      &:hover {
        background: var(--s-800);
      }

      &:active {
        background: var(--s-900);
      }
    }

    .toggle-icon {
      color: var(--s-200);
    }
  }
}
</style>
